// src/components/AnalyticsChart.jsx
import React, { useState } from 'react';

const AnalyticsChart = ({ className = "" }) => {
  const [activeMetric, setActiveMetric] = useState('qualifications');

  const metrics = {
    qualifications: {
      color: '#4f46e5',
      curve: 'M 150,420 Q 200,380 250,360 T 350,340 Q 400,320 450,300 T 550,280 Q 600,270 650,260',
      area: 'M 150,420 Q 200,380 250,360 T 350,340 Q 400,320 450,300 T 550,280 Q 600,270 650,260 L 650,480 L 150,480 Z',
      value: '25',
      change: '+12.5%'
    },
    'taux-reponse': {
      color: '#06b6d4',
      curve: 'M 150,400 Q 200,390 250,380 T 350,370 Q 400,360 450,350 T 550,340 Q 600,330 650,320',
      area: 'M 150,400 Q 200,390 250,380 T 350,370 Q 400,360 450,350 T 550,340 Q 600,330 650,320 L 650,480 L 150,480 Z',
      value: '21%',
      change: '+8.2%'
    },
    entretiens: {
      color: '#10b981',
      curve: 'M 150,440 Q 200,400 250,380 T 350,360 Q 400,340 450,320 T 550,300 Q 600,280 650,250',
      area: 'M 150,440 Q 200,400 250,380 T 350,360 Q 400,340 450,320 T 550,300 Q 600,280 650,250 L 650,480 L 150,480 Z',
      value: '15',
      change: '+15.3%'
    },
    deals: {
      color: '#f59e0b',
      curve: 'M 150,450 Q 200,430 250,410 T 350,390 Q 400,370 450,350 T 550,330 Q 600,310 650,290',
      area: 'M 150,450 Q 200,430 250,410 T 350,390 Q 400,370 450,350 T 550,330 Q 600,310 650,290 L 650,480 L 150,480 Z',
      value: '3',
      change: '+22.1%'
    }
  };

  const currentMetric = metrics[activeMetric];

  return (
    <svg viewBox="0 0 800 600" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#f8fafc', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#e2e8f0', stopOpacity: 1 }} />
        </linearGradient>
        
        <linearGradient id="curveGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: currentMetric.color, stopOpacity: 0.8 }} />
          <stop offset="100%" style={{ stopColor: currentMetric.color, stopOpacity: 0.1 }} />
        </linearGradient>
        
        <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#000000" floodOpacity="0.1"/>
        </filter>
        
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      
      
      {/* Main Container */}
      <rect x="50" y="50" width="700" height="500" rx="20" fill="white" filter="url(#shadow)"/>
      
      {/* Header */}
      <text x="400" y="100" fontFamily="Arial, sans-serif" fontSize="24" fontWeight="bold" fill="#1e293b" textAnchor="middle">
        Analytics Dashboard
      </text>
      
      {/* Interactive Buttons */}
      <g>
        {Object.entries(metrics).map(([key, metric], index) => {
          const isActive = activeMetric === key;
          const x = 100 + (index * 150);
          const buttonLabels = {
            'qualifications': 'Qualifications',
            'taux-reponse': 'Taux de réponse', 
            'entretiens': 'Entretiens',
            'deals': 'Deals'
          };
          
          return (
            <g key={key}>
              <rect 
                x={x} 
                y="130" 
                width="130" 
                height="40" 
                rx="20" 
                fill={isActive ? metric.color : '#e2e8f0'}
                style={{ cursor: 'pointer' }}
                onClick={() => setActiveMetric(key)}
              />
              <text 
                x={x + 65} 
                y="155" 
                fontFamily="Arial, sans-serif" 
                fontSize="14" 
                fontWeight="bold" 
                fill={isActive ? 'white' : '#64748b'} 
                textAnchor="middle"
                style={{ cursor: 'pointer', pointerEvents: 'none' }}
              >
                {buttonLabels[key]}
              </text>
            </g>
          );
        })}
      </g>
      
      {/* Chart Area */}
      <rect x="100" y="200" width="600" height="300" rx="12" fill="#fafafa" stroke="#e2e8f0" strokeWidth="1"/>
      
      {/* Grid Lines */}
      <g stroke="#e2e8f0" strokeWidth="1" opacity="0.5">
        <line x1="100" y1="240" x2="700" y2="240"/>
        <line x1="100" y1="280" x2="700" y2="280"/>
        <line x1="100" y1="320" x2="700" y2="320"/>
        <line x1="100" y1="360" x2="700" y2="360"/>
        <line x1="100" y1="400" x2="700" y2="400"/>
        <line x1="100" y1="440" x2="700" y2="440"/>
        
        <line x1="150" y1="200" x2="150" y2="500"/>
        <line x1="250" y1="200" x2="250" y2="500"/>
        <line x1="350" y1="200" x2="350" y2="500"/>
        <line x1="450" y1="200" x2="450" y2="500"/>
        <line x1="550" y1="200" x2="550" y2="500"/>
        <line x1="650" y1="200" x2="650" y2="500"/>
      </g>
      
      {/* Y-axis Labels */}
      <g fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b" textAnchor="end">
        <text x="95" y="245">100</text>
        <text x="95" y="285">80</text>
        <text x="95" y="325">60</text>
        <text x="95" y="365">40</text>
        <text x="95" y="405">20</text>
        <text x="95" y="445">0</text>
      </g>
      
      {/* X-axis Labels */}
      <g fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b" textAnchor="middle">
        <text x="150" y="520">Jan</text>
        <text x="250" y="520">Fév</text>
        <text x="350" y="520">Mar</text>
        <text x="450" y="520">Avr</text>
        <text x="550" y="520">Mai</text>
        <text x="650" y="520">Jun</text>
      </g>
      
      {/* Active Curve */}
      <g>
        {/* Area under curve */}
        <path d={currentMetric.area} fill="url(#curveGradient)" opacity="0.3"/>
        
        {/* Main curve line */}
        <path 
          d={currentMetric.curve} 
          stroke={currentMetric.color} 
          strokeWidth="4" 
          fill="none" 
          strokeLinecap="round" 
          filter="url(#glow)"
        />
        
        {/* Data points with pulsing animation */}
        {[150, 250, 350, 450, 550, 650].map((x, index) => {
          const yPositions = {
            qualifications: [420, 360, 340, 300, 280, 260],
            'taux-reponse': [400, 380, 370, 350, 340, 320],
            entretiens: [440, 380, 360, 320, 300, 250],
            deals: [450, 410, 390, 350, 330, 290]
          };
          
          return (
            <circle 
              key={index}
              cx={x} 
              cy={yPositions[activeMetric][index]} 
              r="6" 
              fill={currentMetric.color} 
              filter="url(#glow)"
            >
              <animate 
                attributeName="r" 
                values="6;8;6" 
                dur={`${2 + index * 0.3}s`} 
                repeatCount="indefinite"
              />
              <animate 
                attributeName="opacity" 
                values="0.8;1;0.8" 
                dur={`${2 + index * 0.3}s`} 
                repeatCount="indefinite"
              />
            </circle>
          );
        })}
        
        {/* Moving point along the curve */}
        <circle r="8" fill={currentMetric.color} opacity="0.9" filter="url(#glow)">
          <animateMotion 
            dur="6s" 
            repeatCount="indefinite"
            rotate="auto"
          >
            <mpath href="#curvePath"/>
          </animateMotion>
          <animate 
            attributeName="r" 
            values="8;12;8" 
            dur="2s" 
            repeatCount="indefinite"
          />
        </circle>
        
        {/* Invisible path for the moving point */}
        <path 
          id="curvePath"
          d={currentMetric.curve} 
          fill="none" 
          stroke="none"
        />
      </g>
      
      {/* Current Metric Value Display */}
      <g>
        <rect x="580" y="220" width="100" height="60" rx="8" fill="white" filter="url(#shadow)"/>
        <text x="630" y="240" fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b" textAnchor="middle">
          Ce mois
        </text>
        <text x="630" y="260" fontFamily="Arial, sans-serif" fontSize="24" fontWeight="bold" fill={currentMetric.color} textAnchor="middle">
          {currentMetric.value}
        </text>
        <text x="630" y="275" fontFamily="Arial, sans-serif" fontSize="11" fill="#10b981" textAnchor="middle">
          {currentMetric.change}
        </text>
      </g>
      
      {/* Floating Animation Elements */}
      <g opacity="0.6">
        <circle cx="120" cy="150" r="20" fill={currentMetric.color} opacity="0.1"/>
        <rect x="720" y="400" width="30" height="30" rx="8" fill="#06b6d4" opacity="0.1"/>
      </g>
      
      {/* Trend Arrow */}
      <g transform="translate(680, 240)">
        <polygon points="0,0 20,10 15,5 15,15 -5,15 -5,5" fill="#10b981" opacity="0.8"/>
      </g>
    </svg>
  );
};

export default AnalyticsChart;